export const getCurrencyLinkManual = state => {
  return state.link_manual
}



// WEBPACK FOOTER //
// ./src/store/modules/currencies/getters.js